export enum RetailMatchMetricTier {
  Tier1,
  Tier2,
  Tier3,
  Tier4,
}
